import { render, staticRenderFns } from "./qingxuDataBorad.vue?vue&type=template&id=746c6770&scoped=true"
import script from "./qingxuDataBorad.vue?vue&type=script&lang=js"
export * from "./qingxuDataBorad.vue?vue&type=script&lang=js"
import style0 from "./qingxuDataBorad.vue?vue&type=style&index=0&id=746c6770&prod&lang=scss&scoped=true"
import style1 from "./qingxuDataBorad.vue?vue&type=style&index=1&id=746c6770&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c6770",
  null
  
)

export default component.exports